import { Routes } from '@angular/router';
import { UserRouteAccessService } from '../../../services';
import {
    FacultiesComponent,
    FacultyCreateComponent,
    FacultyDetailsComponent,
    FacultyEditComponent,
    FacultyDeleteComponent,
    FacultyDeletePopupComponent
} from '.';

export const FACULTIES_ROUTES: Routes = [
    {
        path: 'faculties',
        component: FacultiesComponent,
        data: {
            authorities: ['ROLE_STAFF'],
            pageTitle: 'faculty.title.main'
        },
        canActivate: [UserRouteAccessService],
    },
    {
        path: 'faculties/create',
        component: FacultyCreateComponent,
        data: {
            authorities: ['ROLE_SUPER_ADMIN'],
            pageTitle: 'faculty.title.create'
        },
        canActivate: [UserRouteAccessService],
    },
    {
        path: 'faculties/details/:id',
        component: FacultyDetailsComponent,
        data: {
            authorities: ['ROLE_STAFF'],
            pageTitle: 'faculty.title.details'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'faculties/edit/:id',
        component: FacultyEditComponent,
        data: {
            authorities: ['ROLE_SUPER_ADMIN'],
            pageTitle: 'faculty.title.edit'
        },
        canActivate: [UserRouteAccessService]
    }
];

export const FACULTIES_POPUPS_ROUTES: Routes = [
    {
        path: 'management/faculties/delete/:id',
        component: FacultyDeletePopupComponent,
        data: {
            authorities: ['ROLE_SUPER_ADMIN'],
            pageTitle: 'faculty.title.main',
            modalComponent: FacultyDeleteComponent
        },
        canActivate: [UserRouteAccessService],
        outlet: 'popup'
    }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/management/faculties/faculties.route.ts